import { render, staticRenderFns } from "./PassengerNum.vue?vue&type=template&id=541d5df8&scoped=true"
import script from "./PassengerNum.vue?vue&type=script&lang=js"
export * from "./PassengerNum.vue?vue&type=script&lang=js"
import style0 from "./PassengerNum.vue?vue&type=style&index=0&id=541d5df8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d5df8",
  null
  
)

export default component.exports